export default __webpack_public_path__ + "static/media/330_dummy2016-consulting01-mobile-de.d649d5a0.png";